import { useTranslation } from "react-i18next";

import { Dropdown } from "components";
import "modules/BrandsDashboard/components/BrandGroupsDropdown/BrandGroupsDropdown.scss";
import { useBrandGroupsDropdown } from "modules/BrandsDashboard/components/BrandGroupsDropdown/hooks";
import { isGroupValue, searchBrandGroups } from "modules/BrandsDashboard/utils";

import type { DropdownItemProps } from "semantic-ui-react";

type BrandGroupsDropdownProps = {
  value: string[];
  handleOnChange: (vinPrefixes: string[]) => void;
};

export const BrandGroupsDropdown = ({ value, handleOnChange }: BrandGroupsDropdownProps) => {
  const { t } = useTranslation();

  const { options, selectedValue, handleOnSelectionChange } = useBrandGroupsDropdown({ selectedVinPrefixes: value, handleOnChange });

  return (
    <div className="BrandGroupsDropdown">
      <Dropdown
        fluid
        clearable
        selection
        multiple
        search={searchBrandGroups}
        name="brands"
        selectOnBlur={false}
        value={selectedValue}
        options={options}
        placeholder={t("v8_groups_brands_vin", "Groups / Brands / Vin #")}
        onChange={handleOnSelectionChange}
        renderLabel={(option: DropdownItemProps) => ({
          content: option.text,
          icon: option.icon,
          className: typeof option.value === "string" && isGroupValue(option.value) ? "brand-group-label" : undefined
        })}
      />
    </div>
  );
};
